import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { RoomTypeModel } from 'types/api'

export function useUpdateRoomType() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function updateRoomType({
    id,
    ...args
  }: { id: string } & RoomTypeModel) {
    const res = await apiClient.patch<RoomTypeModel>(
      SNA_PREFIX + `room-types/${id}`,
      args
    )
    return res.data
  }

  return useMutation({
    mutationFn: updateRoomType,
    onSuccess: () => {
      toast.success({ message: t('roomTypeUpdated') })
      queryClient.invalidateQueries({ queryKey: ['rooms'] })
    },
    onError
  })
}
